import React from "react";

export const PassengersIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.25 4.09375C11.3211 4.09375 13 5.77268 13 7.84375C13 9.91482 11.3211 11.5938 9.25 11.5938C7.17893 11.5938 5.5 9.91482 5.5 7.84375C5.5 5.77268 7.17893 4.09375 9.25 4.09375ZM11.5 7.84375C11.5 6.60111 10.4926 5.59375 9.25 5.59375C8.00736 5.59375 7 6.60111 7 7.84375C7 9.08639 8.00736 10.0938 9.25 10.0938C10.4926 10.0938 11.5 9.08639 11.5 7.84375Z"
        fill="#111111"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 13.0938C14.3211 13.0938 16 14.7727 16 16.8438C16 18.9148 14.3211 20.5938 12.25 20.5938H6.25C4.17893 20.5938 2.5 18.9148 2.5 16.8438C2.5 14.7727 4.17893 13.0938 6.25 13.0938H12.25ZM14.5 16.8438C14.5 15.6011 13.4926 14.5938 12.25 14.5938H6.25C5.00736 14.5938 4 15.6011 4 16.8438C4 18.0864 5.00736 19.0938 6.25 19.0938H12.25C13.4926 19.0938 14.5 18.0864 14.5 16.8438Z"
        fill="#111111"
      />
      <path
        d="M13.4979 10.4824C13.6556 10.229 13.9515 10.0938 14.25 10.0938C15.4926 10.0938 16.5 9.08639 16.5 7.84375C16.5 6.60111 15.4926 5.59375 14.25 5.59375C13.9515 5.59375 13.6556 5.45848 13.4979 5.2051C13.4909 5.19389 13.4839 5.18271 13.4768 5.17157C13.2142 4.75706 13.3473 4.17015 13.835 4.11645C13.9713 4.10145 14.1097 4.09375 14.25 4.09375C16.3211 4.09375 18 5.77268 18 7.84375C18 9.91482 16.3211 11.5938 14.25 11.5938C14.1097 11.5938 13.9713 11.586 13.835 11.571C13.3473 11.5173 13.2142 10.9304 13.4768 10.5159C13.4839 10.5048 13.4909 10.4936 13.4979 10.4824Z"
        fill="#111111"
      />
      <path
        d="M16.5417 18.4106C16.6552 18.2212 16.8556 18.0938 17.0764 18.0938H17.25C18.4926 18.0938 19.5 17.0864 19.5 15.8438C19.5 14.6011 18.4926 13.5938 17.25 13.5938H17.0764C16.8556 13.5938 16.6552 13.4663 16.5417 13.2769C16.2646 12.8146 16.5653 12.0938 17.1043 12.0938H17.25C19.3211 12.0938 21 13.7727 21 15.8438C21 17.9148 19.3211 19.5938 17.25 19.5938H17.1043C16.5653 19.5938 16.2646 18.8729 16.5417 18.4106Z"
        fill="#111111"
      />
    </svg>
  );
};
